export const GRACE_OPTIONS = [
  { value: 1,     label: '1 jour' },
  { value: 2,     label: '2 jours' },
  { value: 3,     label: '3 jours' },
  { value: 4,     label: '4 jours' },
  { value: 0.007, label: '10 min (démo)' },
];

export const GRACE_DEFAULT = 2;
